import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToCheckout = () => {
    const checkoutSection = document.getElementById('checkout');
    if (checkoutSection) {
      checkoutSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 flex justify-between items-center" data-id="element-25">
        <div className="font-heading font-bold text-xl md:text-2xl text-brand-text flex items-center gap-2" data-id="element-26">
          <span className="text-2xl" data-id="element-27">🍳</span>
          <span data-id="element-28">Método 2-2-2</span>
        </div>
        <Button size="sm" onClick={scrollToCheckout} className="shadow-md" data-id="element-29">
          ¡Quiero el Método!
        </Button>
      </div>
    </header>;
}